import axios from 'axios';
import {
    assertValidFormId,
    assertValidLanguage,
} from '../shared/utilities/apiClient';

const REP_FORM_UPDATE_PATH_PREFIX = 'rep/form/update/';

export const saveFormJson = async (
    formId: string,
    json: { [key: string]: any },
    lang: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) => {
    const validatedFormId = assertValidFormId(formId);
    const validatedLang = assertValidLanguage(lang);
    const url = `${REP_FORM_UPDATE_PATH_PREFIX}${validatedFormId}/${validatedLang}`;

    // Client-side relative path; formId and language are validated before use.
    // nosemgrep
    const errors = await axios
        .post(url, json, {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                'Toast-Success-Text': toastText?.onSuccessText,
                SkipToast: true,
            },
        })
        .then((res) => res.data?.errors ?? [])
        .catch((e: any) => {
            const responseData = e?.response?.data;
            if (Array.isArray(responseData?.errors) && responseData.errors.length > 0) {
                return responseData.errors;
            }
            const apiMessage =
                responseData?.message ??
                responseData?.Message ??
                e?.message ??
                'Unknown error';
            return [
                {
                    dataPath: '',
                    error: {
                        message: apiMessage,
                        params: [],
                    },
                },
            ];
        });
    return errors;
};
